// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'forward-solid';

export const Component = () => (
  <path d='m24.219 11.431-7.547 7.116a.426.426 0 0 1-.328.14c-.329 0-.47-.14-.47-.465v-4.28c-2.39 0-4.968.745-7.78 2.28-2.813 1.534-5.063 3.534-6.703 6.046a.493.493 0 0 1-.422.232C.64 22.5.5 22.36.5 22.035v-.046c.234-4.42 1.875-8 4.828-10.698 2.953-2.698 6.469-4.047 10.547-4.047V2.965c0-.325.14-.465.469-.465.14 0 .233.046.328.14l7.547 7.488c.187.14.281.372.281.651 0 .28-.094.512-.281.651v.001Z' />
);

export const viewBox = '0 0 25 25';
